import { render, staticRenderFns } from "./AyarIslem.vue?vue&type=template&id=60c648d0&scoped=true&"
import script from "./AyarIslem.vue?vue&type=script&lang=js&"
export * from "./AyarIslem.vue?vue&type=script&lang=js&"
import style0 from "./AyarIslem.vue?vue&type=style&index=0&id=60c648d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c648d0",
  null
  
)

export default component.exports